import { render, staticRenderFns } from "./itineraries-table.vue?vue&type=template&id=45920eb7&scoped=true&"
import script from "./itineraries-table.ts?vue&type=script&lang=js&"
export * from "./itineraries-table.ts?vue&type=script&lang=js&"
import style0 from "./itineraries-table.vue?vue&type=style&index=0&id=45920eb7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45920eb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VDataTable,VIcon})
